<template>
	<div class="contactUs">
		<!-- <div>
			<div class="introduce">
				<i class="iconfont icon-kefu" style="color: var(--mainColor);font-size: 30px;"></i>
				<p>联系我们</p>
			</div>
			<div>

			</div>
		</div> -->
		<p @click="back">
			<i class="iconfont icon-fanhuidingbu" style="color: #585858;font-size: 27px;"></i>
		</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {


			}
		},
		mounted() {



		},
		methods: {
			back() {
				let target = (document.documentElement || document.body)
				const sTop = target.scrollTop
				const el = window

				this.scrollTop(el, sTop, 0, 1000)
				this.$emit('on-click')
			},
			scrollTop(el, from = 0, to, duration = 500, endCallback) {
				if (!window.requestAnimationFrame) {
					window.requestAnimationFrame = (
						window.webkitRequestAnimationFrame ||
						window.mozRequestAnimationFrame ||
						window.msRequestAnimationFrame ||
						function(callback) {
							return window.setTimeout(callback, 1000 / 60)
						}
					)
				}
				const difference = Math.abs(from - to)
				const step = Math.ceil(difference / duration * 50)

				const scroll = (start, end, step) => {
					if (start === end) {
						endCallback && endCallback()
						return
					}

					let d = (start + step > end) ? end : start + step
					if (start > end) {
						d = (start - step < end) ? end : start - step
					}

					if (el === window) {
						window.scrollTo(d, d)
					} else {
						el.scrollTop = d
					}
					window.requestAnimationFrame(() => scroll(d, end, step))
				}
				scroll(from, to, step)
			}

		}

	}
</script>

<style scoped lang="less">
	.contactUs {
		position: fixed;
		// top: 30%;
		top: 80%;
		right: 20px;

		>div {
			position: relative;

			.introduce {
				width: 50px;
				padding: 10px 0;
				background: #FFFFFF;
				box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.1);
				text-align: center;
				cursor: pointer;

				>p {
					width: 14px;
					font-size: 14px;
					color: #282828;
					margin: 9px auto 0;
				}
			}

			.introduce+div {
				width: 190px;
				height: 180px;
				background: #fff;
				background-size: contain;
				text-align: center;
				position: absolute;
				right: 71px;
				top: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				display: none;
			}

			.introduce:hover+div {
				display: block;
			}

		}

		>p {
			width: 50px;
			background: #FFFFFF;
			box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.1);
			padding: 10px 0;
			margin-top: 7px;
			text-align: center;
			cursor: pointer;
		}

	}
</style>